import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { isMobile, isBreakPointMenuMobile } from "@/js/mobile/mobile.js";
import cart from "@/components/cart/Cart.vue";
import { disconnect, hasRole, getLoggedUserData, isUserBuyerGroup } from "@/js/http/auth.js";
import { getMenuItems } from "@/js/user/user_menu.js";
import * as orderHandler from "@/js/order/order.js";
import { orderStatus } from "@/js/lists.ts";
import footerComponent from "@/components/footer/Footer.vue";
import ScheduledMaintenanceAlert from "@/components/maintenance/ScheduledMaintenanceAlert.vue";
export default {
  name: "userProfile",
  data: function data() {
    return {
      loggedUserData: {},
      menus: [],
      hoverCart: false,
      buyer: true,
      cart: false,
      orderStatus: orderStatus,
      menus_images: [],
      nbItems: 0
    };
  },
  computed: {
    isMaintenanceMode: function isMaintenanceMode() {
      return !this.$maintenanceMode.isActive || hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    }
  },
  mounted: function mounted() {
    this.$EventBus.$on("RemovedItem", this.eventUpdateCart);
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _currentOrder, _currentOrder2, _currentOrder3;
      var currentOrder, getBasketInStandBy, newNbItems, _this, response, seen;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.loggedUserData = getLoggedUserData();
            _context.next = 3;
            return getMenuItems();
          case 3:
            _this2.menus = _context.sent;
            _this2.$EventBus.$on("update-cart", _this2.eventUpdateCart);
            _this2.$EventBus.$on("order-made", _this2.eventOrderMade);
            _this2.buyer = hasRole(process.env.VUE_APP_ROLES_BUYER) || hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            currentOrder = orderHandler.getCurrentOrder();
            if (!(!currentOrder && hasRole(process.env.VUE_APP_ROLES_BUYER))) {
              _context.next = 13;
              break;
            }
            _context.next = 11;
            return request("/v1/basket", "get", null, true, "api");
          case 11:
            getBasketInStandBy = _context.sent;
            if (getBasketInStandBy.data) {
              orderHandler.setCurrentOrder(getBasketInStandBy.data);
            }
          case 13:
            currentOrder = orderHandler.getCurrentOrder();
            if ((_currentOrder = currentOrder) !== null && _currentOrder !== void 0 && _currentOrder.items && ((_currentOrder2 = currentOrder) === null || _currentOrder2 === void 0 ? void 0 : _currentOrder2.creatorUserId) == _this2.loggedUserData.idUser && ((_currentOrder3 = currentOrder) === null || _currentOrder3 === void 0 ? void 0 : _currentOrder3.status) == orderStatus.find(function (x) {
              return x.id == "CREATED";
            }).status) {
              newNbItems = 0;
              currentOrder.items.forEach(function (item) {
                newNbItems += item.quantity;
              });
              _this2.nbItems = newNbItems;
            }
            _this = _this2;
            _context.next = 18;
            return request("/v1/menu", "get", null, true, "api").catch(function () {
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            });
          case 18:
            response = _context.sent;
            seen = new Set();
            _this2.menus_images = _toConsumableArray(response.data.filter(function (item) {
              var isSeen = seen.has(item.route_name);
              seen.add(item.route_name);
              return !isSeen;
            }));
            if (!_this2.$whitelabel.isMyCellarEnabled && _this2.menus_images.findIndex(function (x) {
              return x.route_name == "userCellar";
            }) > -1) {
              _this2.menus_images.splice(_this2.menus_images.findIndex(function (x) {
                return x.route_name == "userCellar";
              }), 1);
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    eventUpdateCart: function eventUpdateCart() {
      var newNbItems = 0;
      if (orderHandler.getCurrentOrder() && orderHandler.getCurrentOrder().items) {
        orderHandler.getCurrentOrder().items.forEach(function (item) {
          newNbItems = newNbItems + item.quantity;
        });
        this.nbItems = newNbItems;
      }
    },
    eventOrderMade: function eventOrderMade() {
      this.nbItems = 0;
    },
    disconnectUser: function disconnectUser() {
      disconnect(this);
    },
    showCart: function showCart(e) {
      this.cart = !this.cart && true;
      e.stopPropagation();
    },
    shutCart: function shutCart(e) {
      if (!this.hoverCart || e.force) this.cart = this.cart && false;
    },
    menuAction: function menuAction(route, query) {
      return {
        name: route,
        query: {
          tab: query
        }
      };
    },
    clickCardMenu: function clickCardMenu(route) {
      var query = null;
      if (route === "userOrderList") query = {
        tab: "orders"
      };
      if (route === "adminOrderList") query = {
        tab: "orders"
      };
      if (route === "adminProductList") query = {
        tab: "wines"
      };
      if (route === "userProductList") query = {
        tab: "wines"
      };
      this.$router.push({
        name: route,
        query: query
      });
    },
    isUserBuyerGroup: isUserBuyerGroup
  },
  components: {
    cart: cart,
    "footer-component": footerComponent,
    ScheduledMaintenanceAlert: ScheduledMaintenanceAlert
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (isMobile() || isBreakPointMenuMobile()) {
      if ((to === null || to === void 0 ? void 0 : to.name) === "finalizeCart") {
        next();
      } else {
        if (this.cart) {
          this.shutCart({
            force: true
          });
          next(false);
        } else {
          next();
        }
      }
    } else {
      if (this.cart) this.shutCart({
        force: true
      });
      next();
    }
  }
};